import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { LanguageProvider } from './context/LanguageContext';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LanguageProvider>
    <App />
  </LanguageProvider>
);

// Firebase service worker disabled until messaging is needed again.
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/firebase-messaging-sw.js')
//     .then(function(registration) {
//       console.log('Service Worker registration successful with scope: ', registration.scope);
//     }, function(err) {
//       console.log('Service Worker registration failed: ', err);
//     });
// }

reportWebVitals();
